import apiClient, { unwrap } from './client'

export interface ComposeAttachment {
  filename: string
  content_type: string
  data: string // base64
}

export interface ComposeSendInput {
  from: string
  recipients: string[]
  subject: string
  body_html: string
  body_text: string
  attachments: ComposeAttachment[]
}

export interface ComposeSendResult {
  subject: string
  total: number
  sent: number
  failed: number
  results: { recipient: string; status: string; error?: string }[]
}

export const composeApi = {
  send(data: ComposeSendInput) {
    return unwrap<ComposeSendResult>(apiClient.post('/compose/send', data))
  },
}